import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig
{
    azureTenant: string;
    azureTokenUrl: string;
    azureClientId: string;
    azureResourceId: string;

    constructor()
    {
        this.azureTenant = process.env.azureTenant;
        this.azureTokenUrl = process.env.azureTokenUrl;
        this.azureClientId = process.env.azureClientId;
        this.azureResourceId = process.env.azureResourceId;
    }
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Classes/AppConfig.ts